import { inject } from '@angular/core';
import {
  HttpInterceptorFn
} from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import {LoadingService} from "../services/loading.service";

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);
  const shouldTrack = ['GET', 'POST','PUT','PATCH','DELETE'].includes(req.method);

  if (shouldTrack) {
    loadingService.start();
  }

  return next(req).pipe(
    finalize(() => {
      if (shouldTrack) {
        loadingService.finish();
      }
    })
  );
};
